<template>
  <div>
    <div v-if="$store.state.isUserLoggedIn">
      <v-navigation-drawer
      fixed
      clipped
      v-model="drawer"
      app
      dark
    >
      <v-list dense>
        <v-list-tile @click="navigateTo('/dashboard')">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Inicio</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/profile')">
          <v-list-tile-action>
            <v-icon>account_box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Perfil</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/profile/reservations')">
          <v-list-tile-action>
            <v-icon>date_range</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Mis Reservas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/reservations')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Reservas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/resources')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>build</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Recursos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/resourcesTypes')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Tipos de Recursos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/ResourcesSchedule')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>today</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Horario de Recursos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/schedule')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>watch_later</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Horarios</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="navigateTo('/admin/users')" v-if="$store.state.user.rol">
          <v-list-tile-action>
            <v-icon>supervisor_account</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Usuarios</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Cerrar sesión</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer></div>
    <v-toolbar dense fixed clipped-left app dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="$store.state.isUserLoggedIn"></v-toolbar-side-icon>
      <v-toolbar-title class="mr-4 align-center">
        <span class="blanco"><a @click="navigateTo('/dashboard')">Salesianos Burgos</a></span>
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: true
  }),
  props: {
    source: String
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    logout () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  .blanco{
    color: white;
  }
  a{
    color: white;
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue